
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"27","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"0","stroke-miterlimit":"10","fill":"#fff"}},[_c('path',{attrs:{"d":"M127.857 90.68c-20.918 0-37.935 17.018-37.935 37.935s17.017 37.935 37.935 37.935 37.935-17.017 37.935-37.935-17.018-37.935-37.935-37.935z"}}),_c('path',{attrs:{"d":"M180.454 1.407H75.26c-40.787 0-73.852 33.065-73.852 73.852v105.198c0 40.784 33.065 73.85 73.852 73.85h105.198c40.784 0 73.85-33.066 73.85-73.853V75.26c0-40.787-33.066-73.852-73.853-73.852zm-52.597 192.988c-36.272 0-65.78-29.508-65.78-65.777 0-36.271 29.508-65.78 65.78-65.78 36.268 0 65.776 29.509 65.776 65.78 0 36.269-29.508 65.777-65.776 65.777zm67.22-131.388c-7.758 0-14.05-6.291-14.05-14.05s6.292-14.05 14.05-14.05 14.05 6.292 14.05 14.05-6.291 14.05-14.05 14.05z"}})])])
          )
        }
      }
    